/**
 * Pont historique Puck → pile d'annulation page + thème
 * (utils/webUndoTimeline), qui vit HORS du contexte <Puck> : le composant
 * feuille PuckHistoryBridge publie ici back/forward, sans abonner WebEditor
 * au store Puck (invariant perf).
 *
 * Partage avec Tiptap : la frappe RichText inline a SON historique Tiptap
 * (dans l'iframe, ProseMirror gère Ctrl+Z nativement). Les raccourcis
 * clavier undo/redo sont gérés par hooks/usePuckUndoHotkeys :
 * les bindings natifs Puck reposent sur e.code (touche physique) et ne
 * matchent jamais sur AZERTY — voir utils/undoShortcut.js.
 */

/** @type {{ undo: () => void, redo: () => void, canUndo: boolean, canRedo: boolean, flush?: () => Promise<void> } | null} */
let current = null;
/** @type {Set<(entry: typeof current) => void>} */
const listeners = new Set();

export function publishPuckHistory(entry) {
  current = entry;
  listeners.forEach((listener) => listener(current));
}

export function getPuckHistory() {
  return current;
}

/** S'abonne aux changements ; renvoie le désabonnement. */
export function subscribePuckHistory(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
